declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

@Component({
  selector: 'oqaview',
  templateUrl: './oqaview.component.html',
    styleUrls: ['./oqaview.component.scss'],
  animations: [routerTransition()]
})

export class OqaViewComponent implements OnInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    @Input() GradingModel: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  //

    CurrentOocyteQualityAssessmentByCodeController: //Observable<OocyteQualityAssessmentByCodeController>;
       OocyteQualityAssessmentByCodeController;
    OocyteQADetails: OocyteQualityAssessmentByCodeController;
    CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;

    LoadScansData() {
        //alert("ScansData")
        this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteQualityAssessmentByCodeController();
    }

    
    GetOocyteQualityAssessmentByCodeController() {
        this.StartRefreshing();

        this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.CycleCode;
        this.CurrentOocyteQualityAssessmentByCodeRequest.ConditionalOperator = 10;

        //alert(this.FormattedCode);
        this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
                    this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
                    //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

                    //data.forEach((v, i, a) => {
                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
                    //});
                    //for (let index = 0; index < data.length; index++){
                    //    //alert(data[index].SingleWellFollicleCoder);

                    //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
                    //}
                    //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
                    //   alert(this.FollicularOocyteInfo.TreatmentCycle);
                    //if (this.FollicularScanEndInfo.ScanDate != null) {
                    //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
                    //  if (SValidFrom.getFullYear() > 1900) {
                    //    console.log('this.UpdateDate >1990');
                    //    this.ScanDate = {

                    //      year: SValidFrom.getFullYear(),
                    //      month: SValidFrom.getMonth() + 1,
                    //      day: SValidFrom.getDate()
                    //    }
                    //  }
                    //}
                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.LoadPatients();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
        //alert("pickup");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    //this.ReceipientActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
                    this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
                    this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadMaturityData();
                    this.LoadMorphologyData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentOocyteMaturityByCycleController: OocyteMaturityByCycleController[];
    CurrentOocyteMaturityByCycleRequest: OocyteMaturityByCycleRequest;

    LoadMaturityData() {
        //alert("ScansData")
        this.CurrentOocyteMaturityByCycleRequest = new OocyteMaturityByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteMaturityByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteMaturityByCycleController();
    }
    //AddRowMaturity() {
    //  if (this.CurrentOocyteMaturityByCycleController == null) {
    //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
    //  }
    //  if (this.CurrentOocyteMaturityByCycleController != null) {

    //    var row = new OocyteMaturityByCycleController();

    //    row.MaturityLevel = "";
    //    row.OccCount = 0;
    //    row.DenudedCount = 0;
    //    this.CurrentOocyteMaturityByCycleController.push(row);
    //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

    //  }

    //}
    GetOocyteMaturityByCycleController() {

        this.CurrentOocyteMaturityByCycleRequest.ConditionalOperator = 10;
        this.CurrentOocyteMaturityByCycleRequest.CycleCode = this.CycleCode;


        this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentOocyteMaturityByCycleController = this.ApiResData.Result;


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentOocyteMorphologyByCycleController: OocyteMorphologyByCycleController[];
    CurrentOocyteMorphologyByCycleRequest: OocyteMorphologyByCycleRequest;

    LoadMorphologyData() {
        //alert("ScansData")
        this.CurrentOocyteMorphologyByCycleRequest = new OocyteMorphologyByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentOocyteMorphologyByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetOocyteMorphologyByCycleController();
    }

    GetOocyteMorphologyByCycleController() {
        // this.StartRefreshing();
        this.CurrentOocyteMorphologyByCycleRequest.ConditionalOperator = 10;
        this.CurrentOocyteMorphologyByCycleRequest.CycleCode = this.CycleCode;

        //alert(this.FormattedCode);
        this.actorservice.GetOocyteMorphologyByCycleController(this.CurrentOocyteMorphologyByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentOocyteMorphologyByCycleController = this.ApiResData.Result;


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

 
 
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
      this.LoadScansData();
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
   
      //alert(this.GradingModel);
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  

  

  

 
  
  //
 
  //

  
 



  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  printoocyte() {
    this.printService.printDocument("oocytequality",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate, Sign1Name: this.SelectedTreatmentCycle.EmbryologistSign,
      }
    );
  }

  printoocytedroplet() {
    this.printService.printDocument("oocytequalitydroplet",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate, Sign1Name: this.SelectedTreatmentCycle.EmbryologistSign,
      }
    );
  }
  
}
